import React from 'react'
import {TrackV2OrderDetailsQuery} from '@data/__generated__/types.main'
import formatNumber from '@i18n/formatNumber'

export interface Props {
  item: TrackV2OrderDetailsQuery['order']['items'][0]
}

export default function Item({item}: Props) {
  return (
    <div className="mb-1">
      <div className="flex text-sm items-center">
        <div
          id={`order-item-quantity-${item._id}`}
          className="border border-gray-200 py-[1px] px-2 mr-1 rounded">
          {item.amount}
        </div>
        <div id={`order-item-name-${item._id}`} className="flex-1 font-semibold">
          {item.productName}
        </div>
        <div id={`order-item-unit-price-${item._id}`}>{formatNumber(item.unitPrice, 'money')}</div>
      </div>
      {item.descriptionItems?.length ? (
        <ul className="mt-1">
          {item.descriptionItems.map((descItem, index) => (
            <li key={index} className="text-sm list-none ml-4">
              {descItem.title}: {descItem.selections.join(', ')}
            </li>
          ))}
        </ul>
      ) : null}
    </div>
  )
}
